import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 部屋名設定ダイアログ
 */
class RoomTextSetting extends Dialog {
    targetRoom: marietta.webcad.item.Room;

    initDone: boolean = false; // 初期化完了

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ターゲットのお部屋
      this.targetRoom = marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Room;
      this.initDone = false;

      // ダイアログのコンテンツ生成
      let id: string = 'roomTextSettingDialog';
      let title: string = '部屋名の設定';

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Room Name Setting'; break;
        default: title = '部屋名の設定'; break;
      }

      let contents: string = '<div class="dialogRoomTextSetting">\n';
      contents += '<table>\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<td><label><input type="checkbox" id="checkShowRoomText"><span class="jp">部屋名を表示する</span><span class="en">Show Room Name</span></label></td>\n';
      contents += '<td><input type="text" id="input_roomText" maxlength="10"><span class="jp">（最大10文字）</span><span class="en">(Max 10 characters)</span></td>\n';
      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<td><label><input type="checkbox" id="checkShowRoomSize"><span class="jp">サイズを表示する</span><span class="en">Show Room Size</label></td>\n';
      contents += '<td>\n';
      contents += '<div id="radioRoomSizeType">\n';
      contents += '<input type="radio" name="roomTextType" id="roomTextType_a"><label for="roomTextType_a"><span class="jp">帖単位</span><span class="en">In Tatami</span></label>\n';
      contents += '<input type="radio" name="roomTextType" id="roomTextType_b"><label for="roomTextType_b"><span class="jp">㎡単位</span><span class="en">In Square Meters</span></label>\n';
      contents += '</div>\n';
      contents += '</td>\n';
      contents += '</tr>\n';
      contents += '<tr>\n';
      contents += '<td><label><input type="checkbox" id="checkShowCeiling"><span class="jp">天井高さを表示する</span><span class="en">Show Ceiling Height</label></td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>';
      let footer: string = '<button id="btnDoneRoomTextSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

      this.createDialog(id, title, contents, footer);

      // ダイアログの初期設定
      this.initMe();

      // イベント設定
      const btn = document.querySelector('#btnDoneRoomTextSetting');
      const checkShowRoomText = document.querySelector('#checkShowRoomText');
      const checkShowRoomSize = document.querySelector('#checkShowRoomSize');
      const checkShowRoomCeiling = document.querySelector('#checkShowCeiling');

      btn.addEventListener('click', this.updateRoomText);
      checkShowRoomText.addEventListener('change', this.updateMe);
      checkShowRoomSize.addEventListener('change', this.updateMe);
      checkShowRoomCeiling.addEventListener('change', this.updateMe);

      const self = this;
      document.getElementById('input_roomText').addEventListener('keydown', self.restrictMaxLength);
      document.getElementById('input_roomText').addEventListener('keyup', self.restrictMaxLength);
      document.getElementById('input_roomText').addEventListener('blur', self.restrictMaxLength);
      document.getElementById('btnClose').addEventListener('click', () => {
        marietta.webcad.WebCADGlobal.removeDialog();
      });
    }

    /**
     * ダイアログの初期設定
     */
    initMe() {
      // 部屋名の表示状態
      const checkShowRoomText = document.querySelector('#checkShowRoomText');
      if (this.targetRoom.overlayText.visible) {
        checkShowRoomText.setAttribute('checked', 'checked');
      } else {
        checkShowRoomText.removeAttribute('checked');
      }

      // 部屋名の取得
      (<HTMLInputElement>document.getElementById('input_roomText')).value = this.targetRoom.overlayText.message;

      // サイズの表示状態
      const checkShowRoomSize = document.querySelector('#checkShowRoomSize');
      if (this.targetRoom.overlayText.areaVisible) {
        checkShowRoomSize.setAttribute('checked', 'checked');
      } else {
        checkShowRoomSize.removeAttribute('checked');
      }

      // サイズの単位
      if ((this.targetRoom as marietta.webcad.item.Room).overlayText.useJyou) {
        document.querySelector('#roomTextType_a').setAttribute('checked', 'checked');
      } else {
        document.querySelector('#roomTextType_b').setAttribute('checked', 'checked');
      }

      // サイズの表示状態
      const checkShowRoomCeiling = document.querySelector('#checkShowCeiling');
      if (this.targetRoom.overlayText.ceilingHeightVisible) {
        checkShowRoomCeiling.setAttribute('checked', 'checked');
      } else {
        checkShowRoomCeiling.removeAttribute('checked');
      }

      // 初期化完了フラグ
      this.initDone = true;

      // 入力制限の更新
      this.updateMe();
    }

    /**
     * ダイアログの更新
     */
    updateMe = () => {
      if (!this.initDone) return;
      //   const checkShowRoomText = document.querySelector('#checkShowRoomText');
      const checkShowRoomSize = document.querySelector('#checkShowRoomSize');
      const checkShowCeiling = document.querySelector('#checkShowRoomSize');

      const enabled: boolean = (<HTMLInputElement>document.getElementById('checkShowRoomText')).checked;
      const sizeEnabled: boolean = (<HTMLInputElement>document.getElementById('checkShowRoomSize')).checked;
      const ceilingEnabled: boolean = (<HTMLInputElement>document.getElementById('checkShowCeiling')).checked;

      if (enabled) {
        document.querySelector('.dialogRoomTextSetting').querySelectorAll('input').forEach((element) => {
          element.removeAttribute('disabled');
        });

        document.querySelector('#checkShowRoomText').removeAttribute('disabled');
        document.querySelector('#checkShowRoomSize').removeAttribute('disabled');
        document.querySelector('#checkShowCeiling').removeAttribute('disabled');
        if (sizeEnabled) {
          document.querySelectorAll('#radioRoomSizeType > input').forEach((element) => {
            element.removeAttribute('disabled');
          });
        } else {
          document.querySelectorAll('#radioRoomSizeType > input').forEach((element) => {
            element.setAttribute('disabled', 'disabled');
          });
        }
      } else {
        document.querySelector('.dialogRoomTextSetting').querySelectorAll('input').forEach((element) => {
          if (element.getAttribute('id') !== 'checkShowRoomText') {
            element.setAttribute('disabled', 'disabled');
          }
        });
        checkShowRoomSize.removeAttribute('checked');
        checkShowCeiling.removeAttribute('checked');
      }
    }

    /**
     * 名前設定の反映
     */
    updateRoomText = () => {
      // 部屋名表示有無
      (this.targetRoom as marietta.webcad.item.Room).overlayText.visible = (<HTMLInputElement>document.getElementById('checkShowRoomText')).checked;

      let RoomName = (<HTMLInputElement>document.getElementById('input_roomText')).value as string;
      RoomName = marietta.webcad.util.EscapeSymbol.escapeSymbol(RoomName);

      // 部屋名称を設定
      (this.targetRoom as marietta.webcad.item.Room).itemInfo.text = RoomName;
      (this.targetRoom as marietta.webcad.item.Room).overlayText.message = RoomName;

      // サイズ表示
      (this.targetRoom as marietta.webcad.item.Room).overlayText.areaVisible = (<HTMLInputElement>document.getElementById('checkShowRoomSize')).checked;
      // eslint-disable-next-line no-multi-assign
      (this.targetRoom as marietta.webcad.item.Room).overlayText.useJyou = (this.targetRoom as marietta.webcad.item.Room).itemInfo.area_use_jyou = (<HTMLInputElement>document.getElementById('roomTextType_a')).checked;

      // 天井高さ表示
      (this.targetRoom as marietta.webcad.item.Room).overlayText.ceilingHeightVisible = (<HTMLInputElement>document.getElementById('checkShowCeiling')).checked;

      // テキストを更新した後、部屋のテキストコンテンツを中央に揃える
      (this.targetRoom as marietta.webcad.item.Room).overlayText.alignTexts(false);
      // 自動レイアウト
      // (this.targetRoom as marietta.webcad.item.Room).overlayText.auto_layout = true;

      // ヒストリ
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

      // ダイアログを閉じる
      this.close();
    }

    /**
     * 部屋名の文字数制限
     */
    restrictMaxLength = (e: Event) => {
      const maxLen: number = 10;
      const $target: HTMLInputElement = <HTMLInputElement>e.currentTarget;
      // 文字数チェック
      const len: number = ($target.value as string).length;
      let str: string;
      if (len <= maxLen) return;
      // 入力制限
      str = $target.value as string;
      str = str.substring(0, maxLen);
      $target.value = str;
    }
}
export default RoomTextSetting;
